<template>
  <div>
    <command-panel
        title="Кабельная линия"
        :save-button="true"
        :save-enabled="valid"
        :delete-button="true"
        :photo-button="true"
        :voice-record-button="true"
        :file-button="true"
        @save="saveItem"
        @delete="showConfirmDelete=true"
        @photo="makePhoto"
        @voiceRecord="showVoiceRecorder=true"
        @file="showFilesList=true"
    />
    <v-form v-model="valid" class="mt-2">

          <v-tabs v-model="tab">
            <v-row justify="center">
              <v-tab>Данные</v-tab>
              <v-tab>Фото</v-tab>
            </v-row>
            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); display: flex !important; flex-direction: column; padding-top: 10px; padding-bottom: 10px;">
                <v-card-text style="flex-grow: 1; overflow: auto;">

                  <v-text-field
                      outlined
                      dense
                      label="Наименование (обязательное поле)"
                      type="text"
                      v-model="model.name"
                      :rules="[required()]"
                      autocomplete="off"
                  ></v-text-field>

                  <v-select
                      outlined
                      dense
                      label="Сетевой комплекс"
                      v-model="model.powerGridComplexId"
                      :items="powerGridComplex"
                      item-text="name"
                      item-value="id"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.powerGridComplexId=null)"
                  ></v-select>

                  <v-select
                      outlined
                      dense
                      label="Класс напряжения (кВ)"
                      v-model="model.voltageClass"
                      :items="voltageClass"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.voltageClass=null)"
                  ></v-select>

                  <v-select
                      outlined
                      dense
                      label="Материал провода"
                      v-model="model.wireMaterial"
                      :items="wireMaterial"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.wireMaterial=null)"
                  ></v-select>

                  <v-select
                      outlined
                      dense
                      label="Кол-во жил"
                      v-model="model.wiresNumber"
                      :items="wiresNumber"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.wiresNumber=null)"
                  ></v-select>

                  <v-select
                      outlined
                      dense
                      label="Сечение (мм2)"
                      v-model="model.wireSquare"
                      :items="wireSquare"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.wireSquare=null)"
                  ></v-select>

                  <v-select
                      outlined
                      dense
                      label="Глубина укладки (м)"
                      v-model="model.depth"
                      :items="depth"
                      :clearable="true"
                      @click:clear="$nextTick(() => model.depth=null)"
                  ></v-select>

                  <v-textarea
                    outlined
                    dense 
                    label="Описание (доп. информация)" 
                    v-model="model.description" 
                    autocomplete="off"
                  ></v-textarea>

                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card outlined style="margin-top: 2px; height: calc(100vh - 16rem); padding: 10px;">
                  <photo-carousel :images="images" @photo="makePhoto" />
              </v-card>
            </v-tab-item>
          </v-tabs>

    </v-form>

    <input type="file" accept="image/*" capture="environment" id="photoInput" @change="savePhoto" hidden>

    <voice-recorder
        v-if="showVoiceRecorder"
        @ok="saveVoiceRecord"
        @cancel="showVoiceRecorder=false"
    />

    <confirm
        v-if="showConfirmDelete"
        header="Удалить?"
        :text="model.name"
        @ok="showConfirmDelete = false; deleteItem();"
        @cancel="showConfirmDelete = false"
    />

    <files-list
        v-if="showFilesList"
        :holder-id="model.id"
        @close="showFilesList=false"
        @deleteFiles="deleteFiles"
    />

  </div>
</template>

<script>
import CommandPanel from "@/components/common/commandPanel";
import validations from "@/validations";
import Confirm from "@/components/common/confirm";
import PhotoCarousel from "@/components/common/photoCarousel";
import {v4 as uuidv4} from "uuid";
import VoiceRecorder from "@/components/common/voiceRecorder";
import FilesList from "@/components/common/filesList";
import common from "@/common";

export default {
  name: 'cableLineItem',

  components: { FilesList, VoiceRecorder, PhotoCarousel, Confirm, CommandPanel },

  props: {
    param: String, // Может быть передан id объекта, если редактируем или пустое значение для новых
  },

  created() {
    this.loadData()
  },

  data() {
    return {
      itemType: 'cableLine',
      loading: false,
      valid: false,
      images: [],
      showConfirmDelete: false,
      showVoiceRecorder: false,
      showFilesList: false,
      src: null,
      ...validations,
      tab: 0,
      model: {
        id: null,
        name: null,
        powerGridComplexId: null,
        locality: null,
        voltageClass: null,
        wireType: null,
        wireMaterial: null,
        length: null,
        wiresNumber: null,
        wireSquare: null,
        depth: null,
        plannedLosses: null,
        description: null,
      },
      powerGridComplex: [],
      voltageClass: [0.23, 0.4, 6, 10, 20, 35, 110],
      wiresNumber: [1, 2, 3, 4, 5],
      wireSquare: [10, 16, 25, 35, 50, 70, 95, 120, 150],
      wireMaterial: ['Медь', 'Алюминий'],
      depth: [0.7, 0.8, 1, 1.2, 1.5, 2],
    }
  },

  methods: {
    async loadData() {
      this.powerGridComplex = await common.getList('powerGridComplex')
      const item = await common.getItem(this.itemType, this.param)
      if (item) {
        Object.assign(this.model, item)
        this.images = await common.getImages(this.model.id)
      }
      else {
        this.model.id = uuidv4()
        this.model.powerGridComplexId = await common.getDefaultPowerGridComplexId()
      }
    },

    async saveItem() {
      this.loading = true
      this.model.description = this.model.description || ""
      await common.saveItem(this.itemType, this.model)
      this.loading = false
      this.$emit('mainPage')
    },

    async deleteItem() {
      await common.deleteItem(this.itemType, this.model.id)
      this.$emit('mainPage')
    },

    makePhoto() {
      document.getElementById('photoInput').click()
    },

    async savePhoto(event) {
      if (event.target.files.length) {
        await common.savePhoto(this.itemType, this.model.id, event.target.files[0], this)
        setTimeout(async () => {
          this.images = await common.getImages(this.model.id)
        }, 300)
        this.tab = 1
      }
    },

    async saveVoiceRecord(voice) {
      this.showVoiceRecorder = false
      if (voice && Array.isArray(voice) && voice.length) {
        await common.saveVoiceRecord(this.itemType, this.model.id, voice)
      }
    },

    async deleteFiles() {
      this.images = await common.getImages(this.model.id)
    },

  },
}
</script>
